<template>
  <a-row :gutter="24">
    <a-col :span="12">
      <a-form-model-item label="起始价" prop="startingPrice">
        <a-input
          v-model="startingPrice"
          disabled
          :suffix="form.floorPriceUnit === 1 ? '元/月' : '元/年'"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="加价幅度" prop="increment">
        <a-input
          placeholder="请输入加价幅度"
          v-model="form.increment"
          :suffix="form.floorPriceUnit === 1 ? '元/月' : '元/年'"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="最高加价倍数">
        <a-input
          placeholder="请输入最高加价倍数"
          v-model="defaultMaximumIncrement"
          disabled
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="是否允许以起始价报价">
        <a-radio-group v-model="defaultAllowStartingQuote" disabled>
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="定时报价开始时间">
            <a-form-model-item
              :style="{
                display: 'inline-block',
                width: '30%',
              }"
            >
              <span style="font-weight: 500;color: red;" > 招租公告起始日期</span>
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '10px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              :style="{
                display: 'inline-block',
                width: 'calc(70% - 10px)',
              }"
            >
              <a-input v-model="defaultStartTime" disabled />
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="定时报价结束时间">
            <a-form-model-item
              :style="{
                display: 'inline-block',
                width: '30%',
              }"
            >
              <span style="font-weight: 500;color: red;"> 招租公告截止日期次工作日</span>
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '10px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              :style="{
                display: 'inline-block',
                width: 'calc(70% - 10px)',
              }"
            >
              <a-input v-model="defaultEndTime" disabled />
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="连续报价开始时间">
            <a-form-model-item
              :style="{
                display: 'inline-block',
                width: '30%',
              }"
              ><span style="font-weight: 500;color: red;"> 招租公告截止日期次工作日 </span>
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '10px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              :style="{
                display: 'inline-block',
                width: 'calc(70% - 10px)',
              }"
            >
              <a-input v-model="defaultTimedQuoteDuration" disabled />
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="连续报价时长">
            <a-form-model-item>
              <a-input
                v-model="defaultcontinuousQuoteDuration"
                suffix="秒"
                disabled
              />
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    startingPrice: {
      type: Number,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      defaultMaximumIncrement: 10,
      defaultAllowStartingQuote: 1,
      defaultStartTime: "10:00",
      defaultEndTime: "15:00",
      defaultTimedQuoteDuration: "15:00",
      defaultcontinuousQuoteDuration: 120,
    };
  },
};
</script>

<style>
</style>